<template>
  <div>
    <v-hover v-slot:default="{ hover }">
      <div>
        <template v-if="item.type === 1">
          <v-text-field dense outlined hide-details :label="item.label" :placeholder="item.placeholder"></v-text-field>
        </template>
        <template v-if="item.type === 2">
          <v-textarea dense outlined hide-details :label="item.label" :placeholder="item.placeholder"></v-textarea>
        </template>
        <template v-if="item.type === 3">
          <template v-if="item.default_value.checkboxtype === 1">
            <v-checkbox :label="item.label" dense></v-checkbox>
          </template>
          <template v-else>
            <v-row class="ma-0" v-if="item.default_value.viewType === 'horizontal'">
                <v-col cols="12" class="pa-0 scroll-styles" style="overflow-x:auto">
                  <v-card flat :class="['d-flex flex-row scroll-width', item.default_value.options.length  >= 6 ? 'checkbox-scroll' : '', fieldDragging ? 'drop-highlight' : '' ]"  tile>
                    <v-card :class="fieldDragging ? 'drop-highlight' : '' " flat tile :width="`${getCheckboxLabelWidth(options)}px`" min-height="60px" :min-width="`${getCheckboxLabelWidth(options)}px`"
                      v-for="(options, index) in item.default_value.options.filter( x => x.isactive)" :key="index">
                      <v-row class="ma-0" no-gutters>
                        <v-checkbox class="mx-1 mt-1 checkbox_position" style="max-width:100px" hide-details v-model="fields[item.name]" :label="options.label" :value="options.value" multiple></v-checkbox>
                      </v-row>
                    </v-card>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else-if="item.default_value.viewType === 'vertical'">
                <v-col class="pa-0 ma-0" cols="12"  v-for="(options, index) in item.default_value.options.filter( x => x.isactive)" :key="index">
                    <v-checkbox class="mx-1 mt-1 checkbox_position" hide-details v-model="fields[item.name]" :label="options.label" :value="options.value" multiple></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-card flat tile :width="`${getCheckboxLabelWidth(options)}px`" class="col-2 text-truncate" min-height="60px" :min-width="`${getCheckboxLabelWidth(options)}px`"
                  v-for="(options, index) in item.default_value.options.filter( x => x.isactive)" :key="index">
                  <v-row class="ma-0" no-gutters>
                   <v-checkbox class="mx-1 mt-1 checkbox_position" hide-details v-model="fields[item.name]" :label="options.label" :value="options.value" multiple></v-checkbox>
                  </v-row>
                </v-card>
              </v-row>
          </template>
        </template>
        <template v-if="item.type === 4">
          <v-radio-group row>
            <v-radio v-for="(option, index) in item.default_value.options ? item.default_value.options.filter(x => x.isactive) : []"
              :label="option.label" :value="option.value" :key="index"></v-radio>
          </v-radio-group>
        </template>
        <template v-if="item.type === 5">
          <template v-if="item.default_value.isAPI">
            <v-autocomplete :multiple="item.default_value.is_multiselect" :items="item.default_value.options" :placeholder="item.placeholder"
              outlined dense :item-text="item.default_value.name" item-value="value" clearable hide-details>
            </v-autocomplete>
          </template>
          <template v-else>
            <v-autocomplete :items="item.default_value.options ? item.default_value.options.filter(x => x.isactive) : []" :label="item.label"
              :multiple="item.default_value.is_multiselect" :placeholder="item.placeholder"
              outlined dense item-text="label" item-value="value" clearable hide-details>
            </v-autocomplete>
          </template>
        </template>
        <template v-if="item.type === 6">
          <v-menu v-model="item.date_menu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field dense outlined hide-details v-model="fields[item.name]" :placeholder="item.placeholder"
                clearable prepend-icon="mdi-calendar" :label="item.label" readonly v-on="on" @click:clear="fields[item.name] = null"></v-text-field>
            </template>
            <v-date-picker no-title  v-model="item.date_value" @input="fields[item.name] = $formatter.parseDate(item.date_value), item.date_menu = false"></v-date-picker>
          </v-menu>
        </template>
        <template v-if="item.type === 7">
          <v-menu ref="menu" v-model="timeMenu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="time" transition="scale-transition"
            offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field dense outlined hide-details v-model="time" :placeholder="item.placeholder" clearable prepend-icon="mdi-timer"
                :label="item.label" readonly v-on="on"></v-text-field>
            </template>
            <v-time-picker v-if="timeMenu" v-model="time" format="24hr" full-width @click:minute="$refs.menu.save(time)"></v-time-picker>
          </v-menu>
        </template>
        <template v-if="item.type === 8">
          <v-switch dense inset :label="item.label" hide-details></v-switch>
        </template>
        <template v-if="item.type === 9">
          <v-file-input dense outlined :label="item.label" hide-details :placeholder="item.placeholder"></v-file-input>
        </template>
        <template v-if="item.type === 10">
          <survey-and-advanceSurvey :item="item" :fields="fieldsData" :expandsurveysection="true"></survey-and-advanceSurvey>
        </template>
       <template v-if="item.type === 11">
        <span class="font-weight-medium">{{ item.label }}</span>
        <v-divider></v-divider>
       </template>
        <template v-if="item.type === 12">
          <v-card class="d-flex align-content-start flex-wrap pa-0" flat :class="fieldDragging ? 'drop-highlight' : '' " tile>
            <v-card min-width="80" v-for="(grid, index) in item.default_value.grid_data.labels" :key="index" class="pa-0 pl-1 text-left" :class="fieldDragging ? 'drop-highlight' : '' " outlined tile>
              <span class="subtitle-2 d-inline-block text-truncate" style="max-width:70px;">{{ grid.label }}</span>
            </v-card>
          </v-card>
        </template>
        <!-- html component content -->
        <template v-if="item.type === 16">
          <div v-html="item.default_value.html_content"></div>
        </template>
        <!-- Advanced survey component -->
        <template v-if="item.type === 19">
          <survey-and-advanceSurvey :item="item" :fields="fieldsData" :expandsurveysection="true"></survey-and-advanceSurvey>
        </template>
        <!-- label component content -->
        <template v-if="item.type === 17">
          <span class='pa-0 subtitle-2' :style="{ fontSize: `${item.default_value.font_size}em !important` }">{{ item.label }}</span>
        </template>
        <template v-if="item.type === 18">
          <v-simple-table :class="fieldDragging ? 'drop-highlight' : '' " class="bordered--table" v-if="item.default_value && item.default_value.grid_data && item.default_value.grid_data.labels">
            <thead>
              <tr>
                <th id="" :style="`min-width:${grid.width}px`" v-for="(grid, index) in item.default_value.grid_data.labels" :key="index">{{ grid.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="(grid, index) in item.default_value.grid_data.labels" :key="index">
                  <template v-if="grid.field.type === fieldTypeConstants.STRING || grid.field.type === fieldTypeConstants.NUMBER">
                    <v-text-field readonly :placeholder="grid.field.type === fieldTypeConstants.STRING ? 'Text' : 'Number'"
                      dense hide-details :type="grid.field.type === fieldTypeConstants.NUMBER ? 'number' : 'text'"></v-text-field>
                  </template>
                  <template v-if="grid.field.type === fieldTypeConstants.CHECKBOX && grid.field.typedata">
                    <v-layout wrap class="col" v-if="grid.field.typedata.listItems">
                      <v-checkbox v-for="(options, index) in grid.field.typedata.listItems" :key="index" readonly class="mt-0 pa-1 mx-1" hide-details
                        :label="options.label" :value="options.value" multiple></v-checkbox>
                    </v-layout>
                  </template>
                  <template v-if="grid.field.type === fieldTypeConstants.RADIOBOX && grid.field.typedata">
                    <v-row class="mx-0" v-if="grid.field.typedata.listItems">
                      <v-radio-group class="mt-0" row hide-details readonly>
                        <v-radio v-for="(options, index) in grid.field.typedata.listItems" :key="index"
                          :label="options.label" :value="options.value"></v-radio>
                      </v-radio-group>
                    </v-row>
                  </template>
                  <template v-if="grid.field.type === fieldTypeConstants.SELECT && grid.field.typedata">
                    <v-autocomplete dense :items="grid.field.typedata.listItems" :label="grid.label"
                      :multiple="grid.field.typedata.isMultiSelect" clearable hide-details
                    item-text="label" item-value="value" readonly></v-autocomplete>
                  </template>
                  <template v-if="grid.field.type === fieldTypeConstants.LABEL">
                    <label v-if="grid.field.typedata">
                      {{grid.field.typedata.labeltext}}
                    </label>
                  </template>
                  <template v-if="grid.field.type === fieldTypeConstants.DATE">
                    <v-menu v-model="item.date_menu" :close-on-content-click="false" max-width="290">
                      <template v-slot:activator="{ on }">
                        <v-text-field dense hide-details v-model="fields[item.name]" clearable prepend-icon="mdi-calendar"
                          readonly v-on="on" @click:clear="fields[item.name] = null"></v-text-field>
                      </template>
                      <v-date-picker no-title readonly v-model="item.date_value"
                        @input="fields[item.name] = parseDate(item.date_value), item.date_menu = false"></v-date-picker>
                    </v-menu>
                  </template>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </template>
        <template v-if="item.type === 13">
          <v-subheader v-if="item.label" class='pa-0'><strong>{{ item.label }}:</strong></v-subheader>
          <VueSignaturePad width="100%" height="250px" class="signature--pad" :class="$vuetify.theme.dark ? 'signature--pad--dark' : ''" :ref="`signaturePad_${item._id}`"/>
        </template>
        <template v-if="item.type === 14">
         <div @dragenter="dragEnter(item._id)" @dragover.prevent @dragleave="hidePanelHighlighter(item._id)" @drop="droppedItem(item)"  class="apply-height-width">
          <v-card class="pa-1 ml-1" :class="fieldDragging || reOrdering ? 'custom_pointer_event' : ''">
            <v-card-title class="pa-1 caption font-weight-bold">
              {{ item.label }}
              <v-spacer></v-spacer>
              <v-btn icon small color="info" fab @click="clonePanelHandler(item)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pa-1" :class="panelDragging ? 'panel-drop-highlight' : ''">
              <v-row v-if="item.panel_fields && item.panel_fields.length" :id="`${item._id}_panelFieldDroppingArea`" class="ma-2">
                <template v-for="subField in item.panel_fields">
                  <v-col cols="12" class="pa-1" :md="!subField.type === 15 && subField.columns ? subField.columns : [10, 11, 12, 14, 18, 15, 19].includes(subField.type) ? '12' : '3'" :key="subField._id">
                    <form-fields :fields="fields" :item="subField" :edit="edit" :remove="remove"></form-fields>
                  </v-col>
                </template>
                <!-- <template v-for="subField in item.panel_fields">
                  <v-col :cols="[10, 11, 12, 14, 18, 15, 19].includes(subField.type) ? 12 : subField.columns" class="pa-1" :key="subField._id">
                    <form-fields :fields="fields" :item="subField" :edit="edit" :remove="remove"></form-fields>
                  </v-col>
                </template> -->
                </v-row>
                 <template v-else>
                    <v-alert color="primary" id="no-fields" class="text-center mb-0 alert-height" outlined dark border="left" prominent>
                      <span class="text-center">
                        {{ $t('message.form.dropFields') }}
                      </span>
                    </v-alert>
                </template>
            </v-card-text>
          </v-card>
          </div>
        </template>
        <template  v-if="item.type === 15">
          <invent-component :gridLabels="item.default_value.grid_header.labels" :gridValues="item.default_value.grid_data.values"></invent-component>
        </template>
        <v-expand-transition>
          <v-layout justify-end>
            <v-fade-transition>
              <v-btn text x-small icon color="info" @click="edit(item)">
                <v-icon v-show="hover">mdi-pencil</v-icon>
              </v-btn>
            </v-fade-transition>
            <v-fade-transition>
              <v-btn text x-small icon color="error" @click="remove(item)">
                <v-icon v-show="hover">mdi-window-close</v-icon>
              </v-btn>
            </v-fade-transition>
          </v-layout>
        </v-expand-transition>
      </div>
    </v-hover>
    <v-dialog v-model="showCloneDialog" persistent width="400" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.confirmation') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.form.sureToCloneFields') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-flex class="text-center">
            <v-btn color="success" class="mr-3" id="cloneConfirm" :loading="loading" @click="confirmToClone">{{ $t('message.common.yes') }}</v-btn>
            <v-btn color="error" id="deleteClose" @click="showCloneDialog=false">{{ $t('message.common.no') }}</v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { componentStatusList } from '@/utils/checklistutils/support_list'
import dataGridConstants from '@/mixins/Checklist/data_grid_component'
import checklist from '@/mixins/Checklist/checklist'
export default {
  mixins: [dataGridConstants, checklist],
  props: {
    item: {
      type: Object
    },
    fields: {
      type: Object
    },
    addToPanel: {
      type: Function
    },
    parseDate: {
      type: Function
    },
    edit: {
      type: Function
    },
    remove: {
      type: Function
    },
    fieldDragging: {
      type: Boolean,
      default: false
    },
    reOrdering: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCloneDialog: false,
      clonedPanel: {},
      loading: false,
      statusList: componentStatusList,
      panelDragging: false,
      isPanelInPanel: false,
      timeMenu: false,
      time: null,
      fieldsData: { answer: '', comments: '', attachments: [], signature: '', date: '' }
    }
  },
  components: {
    'form-fields': () => import('./FormFields.vue'),
    'survey-and-advanceSurvey': () => import('./SurveyAndAdvanceSurvey.vue'),
    'invent-component': () => import('./Invent.vue')
  },
  mounted () {
    this.$root.$on('hideLoadingForCloneFields', () => {
      this.loading = false
      this.showCloneDialog = false
    })
  },
  methods: {
    dragEnter (id) {
      // if (!this.fieldDragging) return
      if (this.reOrdering) return
      let item = JSON.parse(localStorage.getItem('DragData'))
      if (item.type === 14) {
        this.isPanelInPanel = true
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'panelinpanel' })
        return
      } else this.isPanelInPanel = false
      if (!this.fieldDragging) return
      this.panelDragging = true
      this.$root.$emit('isPanelHighlighted', true)
      this.getDropAreaItems(document.getElementById(`${id}_panelFieldDroppingArea`))
    },
    droppedItem (item) {
      if (this.isPanelInPanel) return
      this.hidePanelHighlighter(item._id)
      this.addToPanel(item)
      localStorage.removeItem('DragData')
    },
    hidePanelHighlighter (id) {
      this.isPanelInPanel = false
      if (!this.fieldDragging || !this.panelDragging) return
      this.panelDragging = false
      this.$root.$emit('isPanelHighlighted', false)
      var fieldDropPanel = document.getElementById(`${id}_panelFieldDroppingArea`)
      if (fieldDropPanel) {
        var children = Array.from(fieldDropPanel.children)
        fieldDropPanel.removeChild(children[children.length - 1])
      }
      if (document.querySelector('canvas')) {
        var canvas = document.querySelector('canvas')
        canvas.remove()
      }
    },
    clonePanelHandler (panel) {
      this.showCloneDialog = true
      this.clonedPanel = panel
    },
    confirmToClone () {
      this.loading = true
      this.$root.$emit('clonePanelEvent', this.clonedPanel)
      this.showCloneDialog = false
    },
    getCheckboxLabelWidth (options) {
      options.label = options.label || ''
      return (options.label.length + 100) > 200 ? 250 : (options.label.length + 120)
    }
  },
  watch: {
    isPanelInPanel (val) {
      this.$emit('isPanelInPanel', val)
    }
  },
  beforeDestroy () {
    this.$root.$off('hideLoadingForCloneFields')
  }
}
</script>
<style>
.panel-drop-highlight {
  transition: background-color 0.5s ease !important;
  background-color: #D3D3D3 !important;
  border: 1px dashed #8198af !important;
}
.custom_pointer_event {
  pointer-events: none !important;
}
</style>
<style scoped>
  .fixed-first-column table > tbody > tr > td:nth-child(1),
  .fixed-first-column table > thead > tr > th:nth-child(1) {
    position: sticky;
    width: 100px;
    left: 0;
    top: auto;
    z-index: 10;
    background-color: white;
  }
  .custom_vertical_align {
    display: table;
  }
  .custom_vertical_align > * {
    display: table-cell;
    vertical-align: middle;
  }
.scroll-width {
  scrollbar-width: thin;
}
.checkbox-scroll {
  overflow-x:scroll !important;
  overflow-y:hidden !important
}
.drop-highlight {
    background-color: #D3D3D3 !important;
    transition: background-color 0.5s ease !important;
    border: none !important
}

</style>
